import { datadogRum } from '@datadog/browser-rum';
export const SERVICE_NAME = 'ibk-frontend';
function isTestEnvironment() {
    return typeof process !== 'undefined' && process.env.NODE_ENV === 'test';
}
export const errorCounter = {
    add(value, attributes) {
        if (isTestEnvironment() || value <= 0) {
            return;
        }
        try {
            const error = new Error(attributes.operation);
            datadogRum.addError(error, {
                service: attributes.service,
                error_type: attributes.error,
                operation: attributes.operation,
                ...(attributes.productSlug === undefined ? {} : { product_slug: attributes.productSlug }),
            });
        }
        catch {
        }
    },
};
